import React from 'react';
import cn from 'classnames';
import { ProductCard } from '../product-card';
import classes from './products.scss';
const PRODUCTS_SHOW_QNTY = 6;
export const Products = ({
  isExpand,
  products,
  openRelatedProductBuilder
}) => {
  const relatedProducts = isExpand ? products : products.slice(0, PRODUCTS_SHOW_QNTY);
  return /*#__PURE__*/React.createElement("div", {
    className: cn(classes.row, {
      [classes.expandedRow]: isExpand
    })
  }, !isExpand && /*#__PURE__*/React.createElement("div", {
    className: classes.defaultItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.info
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.infoIcon
  }, "i"), /*#__PURE__*/React.createElement("p", {
    className: classes.text
  }, "Your logo will be in the same position as the main product."), /*#__PURE__*/React.createElement("p", {
    className: classes.text
  }, "We'll send you a production mockup for approval before printing."))), relatedProducts && relatedProducts.map((product, idx) => /*#__PURE__*/React.createElement(ProductCard, {
    product: product,
    key: isExpand ? product._id : idx,
    isExpand: isExpand,
    openRelatedProductBuilder: openRelatedProductBuilder
  })));
};